var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNexus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "Letter_S_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 411,635 53.9,0 0,-77.4 -53.9,0 0,77.4 z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Letter_S_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 464.4,635 c -1.1,-0.3 -2.6,-0.8 -4,-1.3 -10.1,-3.7 -19.1,-7.8 -28.4,-13.3 -6.3,-3.7 -13,-7.9 -17.6,-13.7 -1.5,-1.9 -3.3,-4.9 -2.6,-7.6 1.1,-4.2 8.6,-4.9 15,-4.3 6,0.4 12.7,2 17.9,1.9 4.3,-0.2 7.7,-1.7 8.7,-4.9 1.6,-4.7 -4.6,-10.7 -6.5,-12.6 -9.9,-10 -22.1,-15.4 -35.9,-21.6 11.1,3.7 20.8,7.7 30.6,13.4 6.8,3.9 13.9,8.3 19,14.1 1.5,1.8 3.8,5.1 3.3,7.8 -1,6.4 -14.1,5.2 -21.2,4.3 -3.8,-0.4 -8,-1.5 -12.1,-1.3 -3.9,0.2 -8,1.7 -8.6,4.8 -1.1,5.5 5,11.2 7.4,13.4 9.3,8.8 21.6,15.1 34.3,20.5 0.1,0 1.2,0.4 1,0.4 0,0 -0.1,0 -0.3,0",
    id: "path220"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient230",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-77.46,77.46,0,438,635)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop232",
    style: {
      stopColor: "#a59e9d",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop234",
    style: {
      stopColor: "#665d5c",
      stopOpacity: 1
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient198",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(20.77,-20.77,-20.77,-20.77,262.8,591.1)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop200",
    style: {
      stopColor: "#7bb47d",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop202",
    style: {
      stopColor: "#0c9a48",
      stopOpacity: 1
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient180",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-20.77,-20.77,-20.77,20.77,260.2,591.1)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop182",
    style: {
      stopColor: "#fedc77",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop184",
    style: {
      stopColor: "#ffcd09",
      stopOpacity: 1
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient162",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(21.02,21.02,21.02,-21.02,263.3,593.7)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop164",
    style: {
      stopColor: "#f47d5d",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop166",
    style: {
      stopColor: "#ed2024",
      stopOpacity: 1
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient144",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-22.51,22.51,22.51,22.51,260,593.9)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop146",
    style: {
      stopColor: "#778fc8",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop148",
    style: {
      stopColor: "#2e67b2",
      stopOpacity: 1
    },
    offset: 1
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath114"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 337,617.3 32.6,0 0,-49.5 -32.6,0 0,49.5 z",
    id: "path116"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient126",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-49.52,49.52,0,353.2,617.3)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop128",
    style: {
      stopColor: "#a59e9d",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop130",
    style: {
      stopColor: "#665d5c",
      stopOpacity: 1
    },
    offset: 1
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 292.9,615.5 38.8,0 0,-47.7 -38.8,0 0,47.7 z",
    id: "path92"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient102",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-47.72,47.72,0,312.3,615.5)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop104",
    style: {
      stopColor: "#a59e9d",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop106",
    style: {
      stopColor: "#665d5c",
      stopOpacity: 1
    },
    offset: 1
  })), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 191.6,617.2 43.7,0 0,-49.4 -43.7,0 0,49.4 z",
    id: "path68"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient78",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-49.41,49.41,0,213.5,617.2)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop80",
    style: {
      stopColor: "#a59e9d",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop82",
    style: {
      stopColor: "#665d5c",
      stopOpacity: 1
    },
    offset: 1
  })), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 146.6,617.2 38.7,0 0,-47.4 -38.7,0 0,47.4 z",
    id: "path44"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient54",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2e-6,-47.41,47.41,-2e-6,166,617.2)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop56",
    style: {
      stopColor: "#a59e9d",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop58",
    style: {
      stopColor: "#665d5c",
      stopOpacity: 1
    },
    offset: 1
  })), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 144.3,657 323.4,0 0,-129.7 -323.4,0 0,129.7 z",
    id: "path28"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,792 612,792 612,0.03 0,0.03 0,792 z",
    id: "path34"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient3128",
    xlinkHref: "#linearGradient54",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2e-6,-47.41,47.41,-2e-6,166,617.2)",
    spreadMethod: "pad"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient3130",
    xlinkHref: "#linearGradient78",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-49.41,49.41,0,213.5,617.2)",
    spreadMethod: "pad"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient3132",
    xlinkHref: "#linearGradient102",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-47.72,47.72,0,312.3,615.5)",
    spreadMethod: "pad"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient3134",
    xlinkHref: "#linearGradient126",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-49.52,49.52,0,353.2,617.3)",
    spreadMethod: "pad"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient3136",
    xlinkHref: "#linearGradient144",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-22.51,22.51,22.51,22.51,260,593.9)",
    spreadMethod: "pad"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient3138",
    xlinkHref: "#linearGradient162",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(21.02,21.02,21.02,-21.02,263.3,593.7)",
    spreadMethod: "pad"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient3140",
    xlinkHref: "#linearGradient180",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-20.77,-20.77,-20.77,20.77,260.2,591.1)",
    spreadMethod: "pad"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient3142",
    xlinkHref: "#linearGradient198",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(20.77,-20.77,-20.77,-20.77,262.8,591.1)",
    spreadMethod: "pad"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "linearGradient3144",
    xlinkHref: "#linearGradient230",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-77.46,77.46,0,438,635)",
    spreadMethod: "pad"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4593,0,0,0.4593,-71.89,48.16)",
    id: "g3078"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.271,0,0,4.271,-583.1,-1300)",
    id: "layer1"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,-1.25,-4.982,1083)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath26)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath32)",
    id: "g30"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,-1.25,-4.982,1083)",
    id: "g38"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath42)",
    id: "g40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 152.6,608.4 0,7.1 -6,0 0,-45.7 6.4,0 0,23.8 c 0,12.1 4.2,17.9 14.1,17.9 8,0 11.7,-4.4 11.7,-13.5 l 0,-28.2 6.5,0 0,31 c 0,10.5 -6.3,16.4 -16.5,16.4 -7,0 -12.4,-2.9 -16.2,-8.8",
    id: "path60",
    style: {
      fill: "url(#linearGradient3128)",
      stroke: "none"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,-1.25,-4.982,1083)",
    id: "g62"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath66)",
    id: "g64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 191.6,592.2 c 0,-14.6 9.1,-24.4 22.5,-24.4 9.8,0 16.4,4.2 21,13.5 l -5.8,3.2 c -3.4,-7.3 -8.4,-11 -15.2,-11 -9.2,0 -15.3,6.9 -15.6,19 l 36.3,0 c 0.5,15.2 -8,24.7 -20.9,24.7 -13.1,0 -22.3,-9.8 -22.3,-25 m 21.5,18.9 c 8.4,0 13.6,-4.8 14.2,-13.2 l -28.4,0 c 0.9,8.1 6.7,13.2 14.2,13.2",
    id: "path84",
    style: {
      fill: "url(#linearGradient3130)",
      stroke: "none"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,-1.25,-4.982,1083)",
    id: "g86"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath90)",
    id: "g88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 325.3,615.5 0,-22.8 c 0,-13 -3.1,-19 -13.1,-19 -9.9,0 -12.9,5.9 -12.9,19 l 0,22.8 -6.4,0 0,-26.1 c 0,-14.2 6.8,-21.6 19.4,-21.6 12.7,0 19.4,7.4 19.4,21.6 l 0,26.1 -6.4,0",
    id: "path108",
    style: {
      fill: "url(#linearGradient3132)",
      stroke: "none"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,-1.25,-4.982,1083)",
    id: "g110"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath114)",
    id: "g112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 339.2,604 c 0,-6.6 4.4,-9.9 13,-13.3 6.6,-2.6 10.9,-3.8 10.9,-9.5 0,-4.4 -3.3,-7.5 -8.8,-7.5 -5.5,0 -9.3,2.5 -11.3,7.7 l -6,-3.5 c 2.4,-6.3 8.1,-10.1 16,-10.1 10.4,0 16.6,5.6 16.6,13.8 0,8.5 -4.2,11.3 -12.8,14.3 -7.2,2.4 -10.8,4.2 -10.8,8.7 0,3.8 3.1,6.8 7.6,6.8 4.8,0 8.3,-2.3 9.8,-6.7 l 5.8,3.3 c -2.3,5.8 -7.6,9.3 -15.2,9.3 -8.9,0 -14.8,-5.6 -14.8,-13.3",
    id: "path132",
    style: {
      fill: "url(#linearGradient3134)",
      stroke: "none"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,-1.25,-4.982,1083)",
    id: "g134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 236.8,612.3 18.6,-18.6 4.8,0 0,4.8 -18.7,18.7 -4.7,-4.9",
    id: "path150",
    style: {
      fill: "url(#linearGradient3136)",
      stroke: "none"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,-1.25,-4.982,1083)",
    id: "g152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g160"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 268.1,593.7 18.6,18.6 -4.8,4.9 -18.7,-18.7 0.1,-4.8 4.8,0",
    id: "path168",
    style: {
      fill: "url(#linearGradient3138)",
      stroke: "none"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,-1.25,-4.982,1083)",
    id: "g170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g178"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 255.4,591.1 -18.3,-18.4 4.7,-4.8 18.4,18.4 0,4.8 -4.8,0",
    id: "path186",
    style: {
      fill: "url(#linearGradient3140)",
      stroke: "none"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,-1.25,-4.982,1083)",
    id: "g188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 262.8,591.1 0,-4.8 18.4,-18.4 4.8,4.8 -18.4,18.4 -4.8,0",
    id: "path204",
    style: {
      fill: "url(#linearGradient3142)",
      stroke: "none"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m 481.3,397 1,0 0,-112 -1,0 0,112 z",
    id: "path206",
    style: {
      fill: "#a49e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,-1.25,-4.982,1083)",
    id: "g208"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath212)",
    id: "g210"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Letter_S_2)",
    id: "g216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3073"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 464.7,638.1 -318.1,0 0,-89.6 318.1,0 z",
    id: "path236",
    style: {
      fill: "url(#linearGradient3144)",
      stroke: "none"
    }
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexus);
export default __webpack_public_path__ + "static/media/nexus.46eab6b39569d681eadce335758b6987.svg";
export { ForwardRef as ReactComponent };